import { fetchData, postData } from "./apis";

const path = "/purchase";

export const purchaseReturnDeleteCheckApi = (value) => {
  let endPoint = `${path}/purchase-return-delete-check`;
  return postData(endPoint, value);
};

export const purchaseReturnDeleteApi = (value) => {
  let endPoint = `${path}/purchase-return-delete`;
  return postData(endPoint, value);
};

export const purchaseReturnWithDetailsApi = (value) => {
  let endPoint = `${path}/get-purchase-return-record-with-details`;
  return postData(endPoint, value);
};

export const purchaseRecordnWithDetailsApi = (value) => {
  let endPoint = `${path}/get-purchase-record-with-details`;
  return postData(endPoint, value);
};

export const getPredictionAPI = (value) => {
  let endPoint = `${path}/get-item-sales-prediction`;
  return postData(endPoint, value);
};

export const purchaseOrderRecordnWithDetailsApi = (value) => {
  let endPoint = `${path}/get-purchase-order-record-with-details`;
  return postData(endPoint, value);
};

export const getPurchaseVoucherNumberApi = (value) => {
  let endPoint = `${path}/get-purchase-voucher-no`;
  return postData(endPoint, value);
};

export const getPurchaseOrderInvoiceApi = (value) => {
  let endPoint = `${path}/get-purchase-order-invoice`;
  return postData(endPoint,value);
};

export const getPurchasereturnVoucherApi = (value) => {
  let endPoint = `${path}/get-purchase-return-voucher-no`;
  return postData(endPoint, value);
};

export const purchaseDeleteCheckApi = (value) => {
  let endPoint = `${path}/purchase-delete-check`;
  return postData(endPoint, value);
};

export const purchaseDeleteApi = (value) => {
  let endPoint = `${path}/purchase-delete`;
  return postData(endPoint, value);
};

export const purchaseReturnVoucherApi = (value) => {
  let endPoint = `${path}/purchse-return-vouchers`;
  return postData(endPoint, value);
};

export const purchaseVouchersApi = (value) => {
  let endPoint = `${path}/purchse-vouchers`;
  return postData(endPoint, value);
};

export const getSuppliersApi = (value) => {
  let endPoint = `${path}/get-suppliers`;
  return postData(endPoint, value);
};

export const getSupplierCodeApi = (value) => {
  let endPoint = `${path}/get-supplier-code`;
  return postData(endPoint, value);
};

export const getPurchaseReturnedItemsApi = (val) => {
  let endPoint = `${path}/purchase-returned-items`;
  return postData(endPoint, val);
};